<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data }: ContentBlockComponentProps<ContentType.Link> = $props();
</script>

<Link
	variant={data.variant}
	class={[data.variant === ButtonVariant.Text && "group/underline", "w-fit mx-auto"]}
	href={data.url}
	icon="arrow"
>
	<span class={[data.variant === ButtonVariant.Text && "underline-hover", "leading-none"]}>
		<Formatted text={data.text} />
	</span>
</Link>
